import { render, staticRenderFns } from "./ManageNews.vue?vue&type=template&id=28a1d46c&scoped=true"
import script from "./ManageNews.vue?vue&type=script&lang=js"
export * from "./ManageNews.vue?vue&type=script&lang=js"
import style0 from "./ManageNews.vue?vue&type=style&index=0&id=28a1d46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1d46c",
  null
  
)

export default component.exports